import { configureStore } from '@reduxjs/toolkit'
import headerSlice from '../features/common/headerSlice'
import modalSlice from '../features/common/modalSlice'
import rightDrawerSlice from '../features/common/rightDrawerSlice'
import leadsSlice from '../features/leads/leadSlice'
import callCounterSlice from '../features/callCounter/callCounterSlice' // Import the callCounter slice

const combinedReducer = {
  header: headerSlice,
  rightDrawer: rightDrawerSlice,
  modal: modalSlice,
  lead: leadsSlice,
  callCounter: callCounterSlice, // Add the callCounter slice here
}

export default configureStore({
  reducer: combinedReducer
})
